import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink, NamedLink } from '../../components';
import { EditListingDescriptionForm } from '../../forms';
import config from '../../config';

import css from './EditListingContactPanel.module.css';
import HelpAndContact from '../HelpAndContact/HelpAndContact';

import EditListingInstructionsForm from '../../forms/EditListingInstructionsForm/EditListingInstructionsForm';
import EditListingContactForm from '../../forms/EditListingContactForm/EditListingContactForm';
import moment from 'moment';
import { apiBaseUrl } from '../../util/api';
import axios from 'axios';
import { createSlug } from '../../util/urlHelpers';

const EditListingContactPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    formApi,
    form,
    userNativeLang,
    history,
    onManageDisableScrolling,
    type,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);

  const { publicData } = currentListing.attributes;

  const {
    contactPersonInfo,
    specialInstructions,
    isSameEmailAsProfile,
    TandCagreement,
  } = publicData;

  //for same email as profile
  const profileEmail = currentListing?.author.attributes.email;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingContactInfoPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
          </ListingLink>
        ),
      }}
    />
  ) : (

    <FormattedMessage id="EditListingDescriptionPanel.ListYourJob" />
  );

  const certificateOptions = findOptionsForSelectFilter('certificate', config.custom.filters);

  return (
    <div className={classes}>
      <HelpAndContact />
      <div className={css.editHeadingDiv}>
        <h1 className={css.title}>{panelTitle}</h1>
        {currentListing?.id?.uuid && isPublished && (
          <div>
            <NamedLink
              name="ListingPage"
              params={{
                id: currentListing?.id?.uuid,
                slug: createSlug(currentListing?.attributes?.title || ''),
              }}
            >
              <FormattedMessage id="EditListing.GoToListing" />
            </NamedLink>
          </div>
        )}
      </div>
      <EditListingContactForm
        className={css.form}
        initialValues={{
          firstName: contactPersonInfo?.firstName,
          lastName: contactPersonInfo?.lastName,
          email: contactPersonInfo?.email,
          phoneNumber: contactPersonInfo?.phoneNumber,
          specialInstructions,
          profileEmail,
          isSameEmailAsProfile:
            typeof isSameEmailAsProfile === 'string'
              ? [isSameEmailAsProfile]
              : Array.isArray(isSameEmailAsProfile)
                ? isSameEmailAsProfile
                : null,
          TandCagreement:
            typeof TandCagreement === 'string'
              ? [TandCagreement]
              : Array.isArray(TandCagreement)
                ? TandCagreement
                : null,
        }}
        saveActionMsg={submitButtonText}
        onSubmit={async values => {
          const {
            firstName,
            lastName,
            email,
            phoneNumber,
            specialInstructions,
            profileEmail,
            isSameEmailAsProfile,
            TandCagreement,
          } = values;

          let gigId = currentListing?.attributes?.publicData?.gigId
            ? currentListing?.attributes?.publicData?.gigId
            : null;

          if (!currentListing?.attributes?.publicData?.gigId) {
            const url = `${apiBaseUrl()}/api/user/customid/listing`;
            await axios
              .post(url)
              .then(resp => {
                const { customId } = resp.data;
                console.log(858, customId);
                gigId = customId;
              })
              .catch(e => {
                log.error(e, 1236554);
              });
          }

          const updateValues = {
            publicData: {
              gigId,
              contactPersonInfo: {
                firstName,
                lastName,
                email,
                phoneNumber,
              },
              specialInstructions,
              isSameEmailAsProfile,
              TandCagreement,
              searchtime: moment().valueOf(),
            },
          };

          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        certificateOptions={certificateOptions}
        formApi={form}
        userNativeLang={userNativeLang}
        history={history}
        onManageDisableScrolling={onManageDisableScrolling}
        type={type}
        currentListing={currentListing}
      />
    </div>
  );
};

EditListingContactPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingContactPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingContactPanel;
